// CTA Public Transportation
export const GET_START = 'GET_START';
export const GET_FAILED = 'GET_FAILED';

// CTA Bus Request
export const GET_CTA_BUS_ROUTES = 'GET_CTA_BUS_ROUTES';
export const SET_CTA_BUS_ROUTES = 'SET_CTA_BUS_ROUTES';
export const GET_CTA_BUS_DIRECTIONS = 'GET_CTA_BUS_DIRECTIONS';
export const GET_CTA_BUS_PREDICTIONS = 'GET_CTA_BUS_PREDICTIONS';

export const SET_SELECTED_ROUTE = 'SET_SELECTED_ROUTE';
export const SET_BUS_ROUTE_DESTINATIONS = 'SET_BUS_ROUTE_DESTINATIONS';
export const SET_SELECTED_DESTINATION = 'SET_SELECTED_DESTINATION';
export const SET_BUS_STOPS = 'SET_BUS_STOPS';
export const SET_SELECTED_BUS_STOP = 'SET_SELECTED_BUS_STOP';
export const SET_BUS_STOP_PREDICTIONS = 'SET_BUS_STOP_PREDICTIONS';
export const NO_SERVICE_SCHEDULED = 'NO_SERVICE_SCHEDULED';
export const SET_CTA_TRAIN_ROUTES = 'SET_CTA_TRAIN_ROUTES';
export const SET_SELECTED_TRAIN_LINE = 'SET_SELECTED_TRAIN_LINE';
export const SET_TRAIN_STATIONS = 'SET_TRAIN_STATIONS';
export const SET_SELECTED_TRAIN_STATION = 'SET_SELECTED_TRAIN_STATION';
export const SET_TRAIN_STATION_PREDICTIONS = 'SET_TRAIN_STATION_PREDICTIONS';

